import React, { useEffect } from "react";
import ModalComponent from "../../../../../core/layouts/main/components/Modal";
import { FeeController } from "../../../../../core/config/controllers/FeeController";
import { toast } from "react-toastify";
import Field from "../../../../../core/layouts/main/components/Field";
import { FieldHelper } from "../../../../../core/config/helpers/FieldHelper";
import { PlanHelper } from "../../../../../core/config/helpers/PlanHelper";

export default function FeeModal({show, onHide, infos}) {
    const [data, setData] = React.useState(infos);

    useEffect(()=>{
        if(infos.id){
            infos.planId = infos.id;
            setData(infos)
        }
    },[infos])

    function save() {
        if(data.id){
            FeeController.Update(data)
            toast("Taxa atualizada com sucesso!");
            onHide();
        }else{
            FeeController.Insert(data, (res) => {
                toast("Taxa criada com sucesso!");
                onHide();
            })
        }

    }

    function handleChange(e, type) {
        setData(FieldHelper.OnDataChange(data, e, type));
    }

    return (
        <ModalComponent
            show={show}
            title={data.id ? "Editar Honorário" : "Criar Honorário"}
            onHide={() => onHide()}
            onSubmit={() => save()}>
            
            <Field title="Nome" name={"name"} value={data.name} onChange={(e) => handleChange(e)} />
            <Field title="Valor" name={"price"} hint={"R$"} value={data.price} type={FieldHelper.FieldTypeObj.Number} onChange={(e) => handleChange(e, FieldHelper.FieldTypeObj.Currency)} />
            <Field title="Ciclo de cobrança" 
                name={"billing_cycle"} 
                value={data.billing_cycle} 
                type={FieldHelper.FieldTypeObj.Select} 
                options={PlanHelper.Billing_cycle_list} 
                nameOption={"name"}
                keyOption={"value"}
                onChange={(e) => handleChange(e)} />

            <Field title="Descrição" name={"description"} value={data.description} onChange={(e) => handleChange(e)} type={FieldHelper.FieldTypeObj.TextArea}/>
        </ModalComponent>
    )
}